import { useContext } from "react";
import TranslationProviderContext from "../context/TranslationProviderContext";

export const useTranslationHook = () => {
  const { getTranslationText } = useContext(TranslationProviderContext);
  return getTranslationText;
};
